import { isTouch } from 'Lib/istouch/istouch';
import { isRetina } from 'Lib/isretina/isretina';

if (isTouch()) {
    document.documentElement.classList.add('touch');
}

if (isRetina()) {
    document.documentElement.classList.add('retina');
}